module.exports = __webpack_public_path__ + "edit.svg";